import { useSelector } from 'react-redux';
import { selectCurrentEvent } from './event.slice';

const initialState = {
  event: {},
  contact: {},
  location: {},
  preferences: {},
  event_subtype: {},
};

const useEvent = () => {
  const event = useSelector(selectCurrentEvent);

  return {
    event: event || initialState,
  };
};

export default useEvent;
